import { defineModelFactory } from '@/app/libs/I';

export type StoreModel = {
  path: string,
  value: any
}

/**
 * @deprecated legacy
 */
export const storeModel = defineModelFactory<StoreModel>()({});
